// The ONLY DOM-construction helpers used anywhere in this app. There is no
// innerHTML/insertAdjacentHTML call anywhere in this codebase (grep for
// either at any time to verify) -- ops/dashboard-client-audit.md's
// findings #1-3 were all "API-response-derived string interpolated into
// innerHTML or an inline event-handler attribute." Building every element
// through `el()` (which only ever calls `textContent =`, never sets HTML)
// and attaching listeners through `addEventListener` makes that entire bug
// class structurally impossible here, not just avoided by convention.

type Children = (Node | string | null | undefined | false)[];

export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attrs: Record<string, string> = {},
  children: Children = []
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  for (const [key, value] of Object.entries(attrs)) {
    if (key === "class") {
      node.className = value;
    } else {
      node.setAttribute(key, value);
    }
  }
  for (const child of children) {
    if (child === null || child === undefined || child === false) continue;
    node.append(typeof child === "string" ? document.createTextNode(child) : child);
  }
  return node;
}

export function clear(node: Element): void {
  node.replaceChildren();
}

export function setText(node: Element, value: string): void {
  node.textContent = value;
}
